export default "__VITE_ASSET__cba9f1c8__"